import { getRequest } from 'src/services/requests';
import { PessoaDTO } from '../types/dtos/genericos';

const getPessoa = (search = ''): Promise<PessoaDTO[]> => {
  const querySearch = search
    ? `and (contains(Codigo,'${search}') or contains(NomeCompleto,'${search}') or contains(NomeCompleto,'${search.toUpperCase()}'))`
    : '';

  return new Promise((resolve, reject) => {
    getRequest(
      `/genericos/ge/pessoa/buscar?$top=100&$filter=Codigo ne '' and NomeCompleto ne '' and NomeCompleto ne ' ' and Ativo eq true ${querySearch}&$orderby=NomeCompleto`,
      resolve,
      reject
    );
  });
};

const getPessoaPorRepresentante = (
  empresa: string,
  search = ''
): Promise<PessoaDTO[]> => {
  const querySearch = search
    ? ` and (contains(Codigo,'${search}') or contains(NomeCompleto,'${search}'))`
    : '';

  return new Promise((resolve, reject) => {
    getRequest(
      `genericos/ge/pessoa/BuscarPessoaRepresentante?$top=100&$filter=Codigo ne ''${querySearch}`,
      resolve,
      reject
    );
  });
};

const verificarAutenticacaoA2F = (
  codigoUsuario: string
): Promise<{
  success: boolean;
  messages: string[];
  data: { PossuiAutenticacaoA2F: boolean };
  tipoLogin: string;
}> => {
  return new Promise((resolve, reject) => {
    getRequest(
      `/genericos/ge/usuario/VerificarAutenticacaoA2F?codigoUsuario=${encodeURIComponent(
        codigoUsuario
      )}`,
      resolve,
      reject
    );
  });
};

export { getPessoa, getPessoaPorRepresentante, verificarAutenticacaoA2F };
